// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as HelpRouteImport } from './routes/help'
import { Route as HowToUseRouteImport } from './routes/how-to-use'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ReportRouteImport } from './routes/report'
import { Route as ReportFormRouteImport } from './routes/report-form'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TestConnectionRouteImport } from './routes/test-connection'
import { Route as TokushohoRouteImport } from './routes/tokushoho'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedBillingRouteImport } from './routes/_authenticated/billing'
import { Route as AuthenticatedCreditsHistoryRouteImport } from './routes/_authenticated/credits-history'
import { Route as AuthenticatedCreditsShopRouteImport } from './routes/_authenticated/credits-shop'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedHistoryRouteImport } from './routes/_authenticated/history'
import { Route as AuthenticatedReferralRouteImport } from './routes/_authenticated/referral'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedVoiceChangeRouteImport } from './routes/_authenticated/voice-change'
import { Route as SignupConfirmRouteImport } from './routes/signup.confirm'
import { Route as AuthenticatedAdminContactsRouteImport } from './routes/_authenticated/admin_.contacts'
import { Route as AuthenticatedAdminDeployChecklistRouteImport } from './routes/_authenticated/admin_.deploy-checklist'
import { Route as AuthenticatedAdminLabRouteImport } from './routes/_authenticated/admin_.lab'
import { Route as AuthenticatedAdminLabRunsRouteImport } from './routes/_authenticated/admin_.lab-runs'
import { Route as AuthenticatedAdminModerationRouteImport } from './routes/_authenticated/admin_.moderation'
import { Route as AuthenticatedAdminPromptsRouteImport } from './routes/_authenticated/admin_.prompts'
import { Route as AuthenticatedAdminQaChecklistRouteImport } from './routes/_authenticated/admin_.qa-checklist'
import { Route as AuthenticatedAdminReportsRouteImport } from './routes/_authenticated/admin_.reports'
import { Route as AuthenticatedAdminStripeCheckRouteImport } from './routes/_authenticated/admin_.stripe-check'
import { Route as AuthenticatedAdminVoiceLabRouteImport } from './routes/_authenticated/admin_.voice-lab'
import { Route as AuthenticatedBillingIndexRouteImport } from './routes/_authenticated/billing.index'
import { Route as AuthenticatedBillingCancelRouteImport } from './routes/_authenticated/billing.cancel'
import { Route as AuthenticatedBillingHistoryRouteImport } from './routes/_authenticated/billing.history'
import { Route as AuthenticatedBillingSuccessRouteImport } from './routes/_authenticated/billing.success'
import { Route as AuthenticatedCreateIndexRouteImport } from './routes/_authenticated/create.index'
import { Route as AuthenticatedCreateConfirmRouteImport } from './routes/_authenticated/create.confirm'
import { Route as AuthenticatedCreateFailedRouteImport } from './routes/_authenticated/create.failed'
import { Route as AuthenticatedCreateImageRouteImport } from './routes/_authenticated/create.image'
import { Route as AuthenticatedCreateQualityRouteImport } from './routes/_authenticated/create.quality'
import { Route as AuthenticatedCreateVideoRouteImport } from './routes/_authenticated/create.video'
import { Route as AuthenticatedResultIdRouteImport } from './routes/_authenticated/result.$id'
import { Route as AuthenticatedCreateProcessingIdRouteImport } from './routes/_authenticated/create.processing.$id'
import { Route as AuthenticatedCreateTemplateIndexRouteImport } from './routes/_authenticated/create.template.index'
import { Route as AuthenticatedCreateTemplateGalleryRouteImport } from './routes/_authenticated/create.template.gallery'
import { Route as AuthenticatedCreateTemplateIdPreviewRouteImport } from './routes/_authenticated/create.template.$id.preview'
import { Route as AuthenticatedCreateTemplateIdProcessingRouteImport } from './routes/_authenticated/create.template.$id.processing'
import { Route as AuthenticatedCreateTemplateIdResultRouteImport } from './routes/_authenticated/create.template.$id.result'
import { Route as AuthenticatedCreateTemplateIdStep1ProcessingRouteImport } from './routes/_authenticated/create.template.$id.step1-processing'
import { Route as AuthenticatedCreateTemplateCategoryCategoryRouteImport } from './routes/_authenticated/create.template.category.$category'
import { Route as AuthenticatedCreateImageResultIdRouteImport } from './routes/_authenticated/create_.image.result.$id'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRoute = AuthenticatedRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const HelpRoute = HelpRouteImport.update({
            id: '/help',path: '/help',getParentRoute: () => rootRouteImport
          })
const HowToUseRoute = HowToUseRouteImport.update({
            id: '/how-to-use',path: '/how-to-use',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ReportRoute = ReportRouteImport.update({
            id: '/report',path: '/report',getParentRoute: () => rootRouteImport
          })
const ReportFormRoute = ReportFormRouteImport.update({
            id: '/report-form',path: '/report-form',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const TestConnectionRoute = TestConnectionRouteImport.update({
            id: '/test-connection',path: '/test-connection',getParentRoute: () => rootRouteImport
          })
const TokushohoRoute = TokushohoRouteImport.update({
            id: '/tokushoho',path: '/tokushoho',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedBillingRoute = AuthenticatedBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedCreditsHistoryRoute = AuthenticatedCreditsHistoryRouteImport.update({
            id: '/credits-history',path: '/credits-history',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedCreditsShopRoute = AuthenticatedCreditsShopRouteImport.update({
            id: '/credits-shop',path: '/credits-shop',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedHistoryRoute = AuthenticatedHistoryRouteImport.update({
            id: '/history',path: '/history',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedReferralRoute = AuthenticatedReferralRouteImport.update({
            id: '/referral',path: '/referral',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedVoiceChangeRoute = AuthenticatedVoiceChangeRouteImport.update({
            id: '/voice-change',path: '/voice-change',getParentRoute: () => AuthenticatedRoute
          })
const SignupConfirmRoute = SignupConfirmRouteImport.update({
            id: '/confirm',path: '/confirm',getParentRoute: () => SignupRoute
          })
const AuthenticatedAdminContactsRoute = AuthenticatedAdminContactsRouteImport.update({
            id: '/admin_/contacts',path: '/admin/contacts',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminDeployChecklistRoute = AuthenticatedAdminDeployChecklistRouteImport.update({
            id: '/admin_/deploy-checklist',path: '/admin/deploy-checklist',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminLabRoute = AuthenticatedAdminLabRouteImport.update({
            id: '/admin_/lab',path: '/admin/lab',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminLabRunsRoute = AuthenticatedAdminLabRunsRouteImport.update({
            id: '/admin_/lab-runs',path: '/admin/lab-runs',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminModerationRoute = AuthenticatedAdminModerationRouteImport.update({
            id: '/admin_/moderation',path: '/admin/moderation',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminPromptsRoute = AuthenticatedAdminPromptsRouteImport.update({
            id: '/admin_/prompts',path: '/admin/prompts',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminQaChecklistRoute = AuthenticatedAdminQaChecklistRouteImport.update({
            id: '/admin_/qa-checklist',path: '/admin/qa-checklist',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminReportsRoute = AuthenticatedAdminReportsRouteImport.update({
            id: '/admin_/reports',path: '/admin/reports',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminStripeCheckRoute = AuthenticatedAdminStripeCheckRouteImport.update({
            id: '/admin_/stripe-check',path: '/admin/stripe-check',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminVoiceLabRoute = AuthenticatedAdminVoiceLabRouteImport.update({
            id: '/admin_/voice-lab',path: '/admin/voice-lab',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedBillingIndexRoute = AuthenticatedBillingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedBillingRoute
          })
const AuthenticatedBillingCancelRoute = AuthenticatedBillingCancelRouteImport.update({
            id: '/cancel',path: '/cancel',getParentRoute: () => AuthenticatedBillingRoute
          })
const AuthenticatedBillingHistoryRoute = AuthenticatedBillingHistoryRouteImport.update({
            id: '/history',path: '/history',getParentRoute: () => AuthenticatedBillingRoute
          })
const AuthenticatedBillingSuccessRoute = AuthenticatedBillingSuccessRouteImport.update({
            id: '/success',path: '/success',getParentRoute: () => AuthenticatedBillingRoute
          })
const AuthenticatedCreateIndexRoute = AuthenticatedCreateIndexRouteImport.update({
            id: '/create/',path: '/create/',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedCreateConfirmRoute = AuthenticatedCreateConfirmRouteImport.update({
            id: '/create/confirm',path: '/create/confirm',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedCreateFailedRoute = AuthenticatedCreateFailedRouteImport.update({
            id: '/create/failed',path: '/create/failed',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedCreateImageRoute = AuthenticatedCreateImageRouteImport.update({
            id: '/create/image',path: '/create/image',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedCreateQualityRoute = AuthenticatedCreateQualityRouteImport.update({
            id: '/create/quality',path: '/create/quality',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedCreateVideoRoute = AuthenticatedCreateVideoRouteImport.update({
            id: '/create/video',path: '/create/video',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedResultIdRoute = AuthenticatedResultIdRouteImport.update({
            id: '/result/$id',path: '/result/$id',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedCreateProcessingIdRoute = AuthenticatedCreateProcessingIdRouteImport.update({
            id: '/create/processing/$id',path: '/create/processing/$id',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedCreateTemplateIndexRoute = AuthenticatedCreateTemplateIndexRouteImport.update({
            id: '/create/template/',path: '/create/template/',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedCreateTemplateGalleryRoute = AuthenticatedCreateTemplateGalleryRouteImport.update({
            id: '/create/template/gallery',path: '/create/template/gallery',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedCreateTemplateIdPreviewRoute = AuthenticatedCreateTemplateIdPreviewRouteImport.update({
            id: '/create/template/$id/preview',path: '/create/template/$id/preview',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedCreateTemplateIdProcessingRoute = AuthenticatedCreateTemplateIdProcessingRouteImport.update({
            id: '/create/template/$id/processing',path: '/create/template/$id/processing',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedCreateTemplateIdResultRoute = AuthenticatedCreateTemplateIdResultRouteImport.update({
            id: '/create/template/$id/result',path: '/create/template/$id/result',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedCreateTemplateIdStep1ProcessingRoute = AuthenticatedCreateTemplateIdStep1ProcessingRouteImport.update({
            id: '/create/template/$id/step1-processing',path: '/create/template/$id/step1-processing',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedCreateTemplateCategoryCategoryRoute = AuthenticatedCreateTemplateCategoryCategoryRouteImport.update({
            id: '/create/template/category/$category',path: '/create/template/category/$category',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedCreateImageResultIdRoute = AuthenticatedCreateImageResultIdRouteImport.update({
            id: '/create_/image/result/$id',path: '/create/image/result/$id',getParentRoute: () => AuthenticatedRoute
          })





const AuthenticatedBillingRouteChildren = {
  AuthenticatedBillingCancelRoute: AuthenticatedBillingCancelRoute,AuthenticatedBillingHistoryRoute: AuthenticatedBillingHistoryRoute,AuthenticatedBillingSuccessRoute: AuthenticatedBillingSuccessRoute,AuthenticatedBillingIndexRoute: AuthenticatedBillingIndexRoute
}

const AuthenticatedBillingRouteWithChildren = AuthenticatedBillingRoute._addFileChildren(AuthenticatedBillingRouteChildren)



const AuthenticatedRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRoute,AuthenticatedBillingRoute: AuthenticatedBillingRouteWithChildren,AuthenticatedCreditsHistoryRoute: AuthenticatedCreditsHistoryRoute,AuthenticatedCreditsShopRoute: AuthenticatedCreditsShopRoute,AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,AuthenticatedHistoryRoute: AuthenticatedHistoryRoute,AuthenticatedReferralRoute: AuthenticatedReferralRoute,AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,AuthenticatedVoiceChangeRoute: AuthenticatedVoiceChangeRoute,AuthenticatedAdminContactsRoute: AuthenticatedAdminContactsRoute,AuthenticatedAdminDeployChecklistRoute: AuthenticatedAdminDeployChecklistRoute,AuthenticatedAdminLabRoute: AuthenticatedAdminLabRoute,AuthenticatedAdminLabRunsRoute: AuthenticatedAdminLabRunsRoute,AuthenticatedAdminModerationRoute: AuthenticatedAdminModerationRoute,AuthenticatedAdminPromptsRoute: AuthenticatedAdminPromptsRoute,AuthenticatedAdminQaChecklistRoute: AuthenticatedAdminQaChecklistRoute,AuthenticatedAdminReportsRoute: AuthenticatedAdminReportsRoute,AuthenticatedAdminStripeCheckRoute: AuthenticatedAdminStripeCheckRoute,AuthenticatedAdminVoiceLabRoute: AuthenticatedAdminVoiceLabRoute,AuthenticatedCreateConfirmRoute: AuthenticatedCreateConfirmRoute,AuthenticatedCreateFailedRoute: AuthenticatedCreateFailedRoute,AuthenticatedCreateImageRoute: AuthenticatedCreateImageRoute,AuthenticatedCreateQualityRoute: AuthenticatedCreateQualityRoute,AuthenticatedCreateVideoRoute: AuthenticatedCreateVideoRoute,AuthenticatedResultIdRoute: AuthenticatedResultIdRoute,AuthenticatedCreateIndexRoute: AuthenticatedCreateIndexRoute,AuthenticatedCreateProcessingIdRoute: AuthenticatedCreateProcessingIdRoute,AuthenticatedCreateTemplateGalleryRoute: AuthenticatedCreateTemplateGalleryRoute,AuthenticatedCreateTemplateIndexRoute: AuthenticatedCreateTemplateIndexRoute,AuthenticatedCreateTemplateIdPreviewRoute: AuthenticatedCreateTemplateIdPreviewRoute,AuthenticatedCreateTemplateIdProcessingRoute: AuthenticatedCreateTemplateIdProcessingRoute,AuthenticatedCreateTemplateIdResultRoute: AuthenticatedCreateTemplateIdResultRoute,AuthenticatedCreateTemplateIdStep1ProcessingRoute: AuthenticatedCreateTemplateIdStep1ProcessingRoute,AuthenticatedCreateTemplateCategoryCategoryRoute: AuthenticatedCreateTemplateCategoryCategoryRoute,AuthenticatedCreateImageResultIdRoute: AuthenticatedCreateImageResultIdRoute
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(AuthenticatedRouteChildren)




const SignupRouteChildren = {
  SignupConfirmRoute: SignupConfirmRoute
}

const SignupRouteWithChildren = SignupRoute._addFileChildren(SignupRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRoute: AuthenticatedRouteWithChildren,ContactRoute: ContactRoute,ForgotPasswordRoute: ForgotPasswordRoute,HelpRoute: HelpRoute,HowToUseRoute: HowToUseRoute,LoginRoute: LoginRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,ReportRoute: ReportRoute,ReportFormRoute: ReportFormRoute,ResetPasswordRoute: ResetPasswordRoute,SignupRoute: SignupRouteWithChildren,TermsRoute: TermsRoute,TestConnectionRoute: TestConnectionRoute,TokushohoRoute: TokushohoRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)